module.exports = __webpack_public_path__ + "media/assets/cnn-politics-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/cnn-politics-logo.svg
// module id = 28
// module chunks = 0